"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _classnames = _interopRequireDefault(require("classnames"));
require("./Tooltip.scss");
const Tooltip = _ref => {
  let {
    children,
    content,
    isVisible,
    hasPositionCalculated,
    positionConfig,
    onMouseEnter,
    onMouseLeave,
    onClick,
    wrapperRef,
    contentRef,
    hasTriggerWidth = false,
    className,
    triggerClassName,
    contentClassName,
    wrapperClassName,
    handleMouseOver
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-Tooltip', className);
  const triggerComponentClassName = (0, _classnames.default)('cds-Tooltip-Trigger', triggerClassName);
  const portalClassName = (0, _classnames.default)('cds-Tooltip-Content', `cds-Tooltip-Content--${positionConfig.orientation}`, {
    'cds-Tooltip-Content--FullWidth': hasTriggerWidth
  }, contentClassName);
  const Portal = _ref2 => {
    let {
      left,
      top,
      width,
      className
    } = _ref2;
    return /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react.default.createElement("div", {
      style: {
        left,
        top,
        ...(!hasPositionCalculated && {
          opacity: 0
        }),
        ...(hasTriggerWidth && {
          width
        })
      },
      className: (0, _classnames.default)('cds-Tooltip-PortalWrapper', className)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: portalClassName,
      ref: contentRef,
      onMouseOver: handleMouseOver
    }, content)), document.body);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: wrapperRef,
    className: rootClassName,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: triggerComponentClassName
  }, children), isVisible && content && /*#__PURE__*/_react.default.createElement(Portal, {
    left: positionConfig.left,
    top: positionConfig.top,
    width: positionConfig.width,
    className: wrapperClassName
  }));
};
exports.Tooltip = Tooltip;
//# sourceMappingURL=Tooltip.js.map